import React from 'react';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
const CarrierAccountAccessConfirmationModal = (props) => {
    const { t } = useTranslation();
    const { handleCancelButtonClick, handleSubmitButtonClick } = props;
    return (React.createElement("div", null,
        React.createElement("p", null, t('CONFIRM_REQUEST_ACCESS_INFO')),
        React.createElement("p", { className: "mt-3" },
            React.createElement("span", { className: "font-bold underline" }, titleize(t('NOTE', { count: 1 }))),
            ": ",
            t('CONFIRM_REQUEST_ACCESS_NOTE')),
        React.createElement("div", { className: "mt-10 flex justify-around" },
            React.createElement("button", { onClick: handleCancelButtonClick, className: "button button-hollow-green w-1/3" }, t('CANCEL')),
            React.createElement("button", { onClick: handleSubmitButtonClick, className: "button button-green" }, t('CONFIRM_REQUEST_ACCESS')))));
};
export default CarrierAccountAccessConfirmationModal;
